import { rankingsConstants } from '../_constants';

export function rankings(
  state = { fetchingDetail: false, weeklyDetail: {} , monthlyDetail: {} },
  action
) {
  switch (action.type) {
    case rankingsConstants.DETAIL_REQUEST:
      return {
        ...state,
        fetchingDetail: true
      };
    case rankingsConstants.DETAIL_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        weeklyDetail: action.detail
      };
    case rankingsConstants.MONTHLY_DETAIL_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        monthlyDetail: action.detail
      };
    case rankingsConstants.DETAIL_FAILURE:
      return {};
    default:
      return state;
  }
}
